import Typography from "@mui/material/Typography";

export default function DashboardPage() {
  return (
    <Typography>Bienvenido al nuevo sistema de carga de prácticas</Typography>
  );
}
